<template>
  <div class="p-4 md:p-8 min-h-screen bg-gray-900 flex items-center justify-center">
    <div class="w-full max-w-lg bg-gray-800 p-8 rounded-xl shadow-2xl">
      <h2 class="text-3xl font-extrabold text-white text-center mb-6">Get in Touch</h2>

      <form @submit.prevent="submitForm" class="space-y-6">
        <!-- Success Message -->
        <div v-if="successMessage" class="p-4 bg-green-500 rounded-lg text-white font-semibold text-center transition duration-300">
          {{ successMessage }}
        </div>

        <!-- Error Message -->
        <div v-if="errorMessage" class="p-4 bg-red-600 rounded-lg text-white font-semibold text-center transition duration-300">
          {{ errorMessage }}
        </div>

        <div>
          <label for="name" class="block text-sm font-medium text-gray-300 mb-1">Name</label>
          <input
              type="text"
              id="name"
              v-model="form.name"
              required
              :disabled="isSubmitting"
              class="w-full px-4 py-2 border border-gray-600 rounded-lg bg-gray-700 text-white focus:ring-blue-500 focus:border-blue-500 transition duration-150"
          >
        </div>

        <div>
          <label for="email" class="block text-sm font-medium text-gray-300 mb-1">Email</label>
          <input
              type="email"
              id="email"
              v-model="form.email"
              required
              :disabled="isSubmitting"
              class="w-full px-4 py-2 border border-gray-600 rounded-lg bg-gray-700 text-white focus:ring-blue-500 focus:border-blue-500 transition duration-150"
          >
        </div>

        <div>
          <label for="subject" class="block text-sm font-medium text-gray-300 mb-1">Subject</label>
          <input
              type="text"
              id="subject"
              v-model="form.subject"
              required
              :disabled="isSubmitting"
              class="w-full px-4 py-2 border border-gray-600 rounded-lg bg-gray-700 text-white focus:ring-blue-500 focus:border-blue-500 transition duration-150"
          >
        </div>

        <div>
          <label for="message" class="block text-sm font-medium text-gray-300 mb-1">Message</label>
          <textarea
              id="message"
              v-model="form.message"
              rows="5"
              required
              :disabled="isSubmitting"
              class="w-full px-4 py-2 border border-gray-600 rounded-lg bg-gray-700 text-white focus:ring-blue-500 focus:border-blue-500 resize-none transition duration-150"
          ></textarea>
        </div>

        <button
            type="submit"
            :disabled="isSubmitting"
            class="w-full py-3 px-4 rounded-lg font-bold text-lg transition duration-300 shadow-md
                 focus:outline-none focus:ring-4 focus:ring-blue-500/50"
            :class="{
            'bg-blue-600 text-white hover:bg-blue-700': !isSubmitting,
            'bg-blue-400 text-gray-200 cursor-not-allowed': isSubmitting
          }"
        >
          <span v-if="!isSubmitting">Send Message</span>
          <span v-else>Sending...</span>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactPage',
  data() {
    return {
      form: {
        name: '',
        email: '',
        subject: '',
        message: '',
      },
      isSubmitting: false,
      successMessage: '',
      errorMessage: '',
      // --- IMPORTANT: This must match the route in server.js ---
      backendEndpoint: '/api/contact',
    };
  },
  methods: {
    async submitForm() {
      // 1. Reset messages and set loading state
      this.successMessage = '';
      this.errorMessage = '';
      this.isSubmitting = true;

      try {
        const response = await fetch(this.backendEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(this.form),
        });

        // 2. Parse response (whether success or error)
        const data = await response.json();

        if (response.ok) {
          // Success (200-299 status code)
          this.successMessage = 'Thank you! Your message has been sent successfully.';
          // Clear the form fields on success
          this.form = { name: '', email: '', subject: '', message: '' };
        } else {
          // Server-side error (4xx or 5xx status code)
          this.errorMessage = data.error || 'An unexpected error occurred while sending the message.';
        }
      } catch (error) {
        // Network error (e.g., server is down, connection lost)
        console.error('Network Error:', error);
        this.errorMessage = 'Could not reach the server. Please try again later.';
      } finally {
        // 3. Stop loading and ensure messages fade after a while
        this.isSubmitting = false;

        if (this.successMessage) {
          setTimeout(() => this.successMessage = '', 5000); // Clear success after 5s
        }
      }
    },
  },
};
</script>
